/**
 * @author: Beka Chkhaidze
 * @summary: used to get data from /getDataList API
 */

import { ref } from "vue";
import { reqAxios } from "@/composables/core/func";
import { SecondaryDataInterface } from "@/types/ContentType";
import { extractFromQuery } from "@/composables/utils/router";
import { useMainStore } from "@/store/main/index";

import type { State, FetchParams } from "./state.interface";
import type { MenuInterface } from "@/store/main/types/StateType";

const blogData = ref<SecondaryDataInterface["data"]>();

export const fetchData = async (
  state: State,
  contentData: SecondaryDataInterface | undefined
): Promise<typeof blogData.value> => {
  const selectedMenuState = useState<MenuInterface | undefined>("selectedMenu");

  const store = useMainStore();

  const taxonomyId = store.terms?.media_categories?.find(
    (el) => el.slug === state.category
  )?.id;

  const params: FetchParams = {
    id: selectedMenuState.value?.id!,
    componentUnicId: contentData?.conf?.unicId,
    searchText: state.searchText,
    pageNumber: Number(extractFromQuery("page")) || 1,
    perPage: state.perPage,
    selectedlan: store.lang,
  };

  if (taxonomyId) {
    params.taxonomies = {
      media_categories: [taxonomyId],
    };
  }

  const queryYear = Number(extractFromQuery("year"));
  if (queryYear) {
    params.searchDate = [queryYear];
  }

  state.isLoading = true;
  const { data, status } = await reqAxios("main/getDataList", params);

  if (status == 200) {
    blogData.value = data;
  } else {
    blogData.value = {
      list: [],
      listCount: 0,
      page: 1,
    };
  }

  setTimeout(() => {
    state.isLoading = false;
  }, 300);

  return blogData.value;
};
